/* Shared "Columns" show/hide popover for month columns — used by both Summary.js's matrix and
   DetailsTable.js's pivoted grid, same role a Columns picker plays elsewhere in this app
   (IndirectSummaryTab.js's Labor/Non-Labor grids). Each caller owns its own hidden-months state
   (persisted to its own localStorage key) since Summary and Details may reasonably want
   different months hidden. */
import React, { useEffect, useRef, useState } from "react";
import { TABLE_FONT } from "../../reportTableConfig";
import { monthKeyLabel } from "./fteReportUtils";

const FONT = TABLE_FONT;

export default function MonthColumnPicker({ monthKeys, hidden, onToggle, onReset }) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  const hiddenCount = hidden.length;
  const isActive = open || hiddenCount > 0;

  return (
    <div ref={wrapRef} style={{ position: "relative", display: "inline-flex" }}>
      <button
        type="button"
        style={{
          display: "inline-flex", alignItems: "center", gap: 6, height: 32,
          padding: "0 12px", borderRadius: 6, fontFamily: FONT,
          border: `1px solid ${isActive ? "#C7D2FE" : "#E2E8F0"}`,
          background: isActive ? "#EEF2FF" : "#fff",
          color: isActive ? "#4F46E5" : "#374151",
          fontSize: 12, fontWeight: 500, cursor: "pointer",
        }}
        onClick={() => setOpen((p) => !p)}
      >
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="3" y="3" width="7" height="18" rx="1" /><rect x="14" y="3" width="7" height="18" rx="1" />
        </svg>
        Columns
        {hiddenCount > 0 && (
          <span style={{ display: "inline-flex", alignItems: "center", height: 18, padding: "0 7px", borderRadius: 10, background: "#4F46E5", color: "#fff", fontSize: 11, fontWeight: 600 }}>
            {hiddenCount} Hidden
          </span>
        )}
      </button>
      {open && (
        <div style={{ position: "absolute", top: "calc(100% + 6px)", right: 0, zIndex: 1200, background: "#fff", borderRadius: 10, border: "1px solid #E5E7EB", boxShadow: "0 8px 24px rgba(0,0,0,0.12)", minWidth: 220, maxHeight: 360, overflowY: "auto", fontFamily: FONT }}>
          <div style={{ padding: "8px 14px", background: "#F8FAFC", borderBottom: "1px solid #E2E8F0", fontSize: 12, fontWeight: 700, color: "#111827", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span>Visible Months</span>
            <button type="button" onClick={onReset} style={{ border: "none", background: "none", color: "#4F46E5", fontSize: 11, fontWeight: 600, cursor: "pointer", padding: 0 }}>
              Show All
            </button>
          </div>
          <div style={{ padding: "4px 0 8px" }}>
            {monthKeys.map((key) => (
              <label key={key} style={{ display: "flex", alignItems: "center", gap: 10, padding: "6px 14px", cursor: "pointer", fontSize: 12, color: "#374151" }}>
                <input
                  type="checkbox"
                  checked={!hidden.includes(key)}
                  onChange={() => onToggle(key)}
                  style={{ width: 14, height: 14, accentColor: "#4F46E5", cursor: "pointer", flexShrink: 0 }}
                />
                <span>{monthKeyLabel(key)}</span>
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
